var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaybe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PMS / maybe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMS-/-maybe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.201596,6.75496494 L21.1155676,17.9490142 C21.696011,18.8887798 21.4047229,20.1211526 20.4649574,20.701596 C20.1491126,20.8966766 19.7852052,21 19.4139716,21 L5.58602838,21 C4.48145888,21 3.58602838,20.1045695 3.58602838,19 C3.58602838,18.6287664 3.68935179,18.264859 3.88443238,17.9490142 L10.798404,6.75496494 C11.3788474,5.81519943 12.6112202,5.5239113 13.5509858,6.10435471 C13.8154722,6.26771397 14.0382367,6.49047853 14.201596,6.75496494 Z",
    id: "Triangle",
    fill: "#B5D7F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaybe);
export default __webpack_public_path__ + "static/media/icon_maybe.b5dc16c9ebb3121d7fd1810191303e54.svg";
export { ForwardRef as ReactComponent };